export default function PHP_query() {
  return (
    <div>
      <h1>PHP_query</h1>
    </div>
  );
}
